type CmdAboutChatbotProp = {
    text : string
}
const CmdAboutChatbot = ({text} : CmdAboutChatbotProp) => {
  return (
    <span className="bg-[#1A1A1A] text-subColor5 px-2 mx-1 rounded-md pr-6 py-1">
      {text}
    </span>
  );
};

export default CmdAboutChatbot;
